export default __webpack_public_path__ + "static/media/regalxReal02_downloadMT4.534a842a.png";